import { render, staticRenderFns } from "./ProductTypeDetails.vue?vue&type=template&id=850d615c&"
import script from "./ProductTypeDetails.vue?vue&type=script&lang=js&"
export * from "./ProductTypeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports